import { c as _c } from "react/compiler-runtime";
import React from "react";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface WinnerDropBadgeProps {
  rank: number | null;
  round?: number;
  position?: number;
  decisionTime: number | null;
  variant?: "default" | "simple";
}
const WinnerDropBadge: React.FC<WinnerDropBadgeProps> = t0 => {
  const $ = _c(26);
  const {
    rank,
    round: t1,
    position: t2,
    decisionTime,
    variant: t3
  } = t0;
  t1 === undefined ? 1 : t1;
  const position = t2 === undefined ? 1 : t2;
  const variant = t3 === undefined ? "default" : t3;
  const effectiveRank = rank !== null && rank !== undefined ? rank : position;
  if (!effectiveRank) {
    return null;
  }
  const rankNumber = typeof effectiveRank === "string" ? parseInt(effectiveRank, 10) : effectiveRank;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function getOrdinalSuffix(n) {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod10 === 1 && mod100 !== 11) {
        return "st";
      }
      if (mod10 === 2 && mod100 !== 12) {
        return "nd";
      }
      if (mod10 === 3 && mod100 !== 13) {
        return "rd";
      }
      return "th";
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const getOrdinalSuffix = t4;
  let dateString;
  let t5;
  if ($[1] !== decisionTime) {
    const dateTime = decisionTime ? new Date(decisionTime) : null;
    dateString = dateTime ? dateTime.toLocaleString(undefined, {
      month: "short",
      day: "numeric"
    }) : null;
    t5 = dateTime ? dateTime.toLocaleString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    }) : null;
    $[1] = decisionTime;
    $[2] = dateString;
    $[3] = t5;
  } else {
    dateString = $[2];
    t5 = $[3];
  }
  const timeString = t5;
  let colorClasses;
  let textColorClass;
  let rankText;
  bb0: switch (rankNumber) {
    case 1:
      {
        colorClasses = "tw-bg-yellow-500/10 tw-text-yellow-400 tw-border-yellow-500/20";
        textColorClass = "tw-text-amber-400";
        rankText = "1st";
        break bb0;
      }
    case 2:
      {
        colorClasses = "tw-bg-iron-400/10 tw-text-iron-300 tw-border-iron-400/20";
        textColorClass = "tw-text-iron-300";
        rankText = "2nd";
        break bb0;
      }
    case 3:
      {
        colorClasses = "tw-bg-amber-600/10 tw-text-amber-500 tw-border-amber-600/20";
        textColorClass = "tw-text-amber-600";
        rankText = "3rd";
        break bb0;
      }
    default:
      {
        colorClasses = "tw-bg-iron-600/20 tw-text-iron-400 tw-border-iron-600/20";
        textColorClass = "tw-text-iron-500";
        rankText = `${rankNumber}${getOrdinalSuffix(rankNumber)}`;
      }
  }
  if (variant === "simple") {
    const t6 = `tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-semibold ${textColorClass}`;
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <FontAwesomeIcon icon={faTrophy} className="tw-w-3.5 tw-h-3.5" />;
      $[4] = t7;
    } else {
      t7 = $[4];
    }
    const t8 = position > 1 && ` #${position}`;
    let t9;
    if ($[5] !== rankText || $[6] !== t8) {
      t9 = <span>{rankText}{t8}</span>;
      $[5] = rankText;
      $[6] = t8;
      $[7] = t9;
    } else {
      t9 = $[7];
    }
    let t10;
    if ($[8] !== dateString || $[9] !== timeString) {
      t10 = dateString && <span>· {dateString}{timeString && <span className="tw-hidden sm:tw-inline">, {timeString}</span>}</span>;
      $[8] = dateString;
      $[9] = timeString;
      $[10] = t10;
    } else {
      t10 = $[10];
    }
    let t11;
    if ($[11] !== t10 || $[12] !== t6 || $[13] !== t9) {
      t11 = <div className={t6}>{t7}{t9}{t10}</div>;
      $[11] = t10;
      $[12] = t6;
      $[13] = t9;
      $[14] = t11;
    } else {
      t11 = $[14];
    }
    return t11;
  }
  const t6 = `tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-semibold tw-border tw-border-solid tw-whitespace-nowrap ${colorClasses}`;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon icon={faTrophy} className="tw-size-2.5" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== position) {
    t8 = position > 1 && <span>#{position}</span>;
    $[16] = position;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== dateString || $[19] !== timeString) {
    t9 = dateString && <span className="tw-hidden md:tw-flex tw-items-center"><div className="tw-size-[3px] tw-rounded-full tw-bg-current tw-opacity-70" /><span className="tw-border-l tw-border-current/40 tw-px-2 tw-flex tw-items-center"><FontAwesomeIcon icon={faClock} className="tw-mr-1.5 tw-size-2.5" />{dateString}{timeString && <span className="tw-hidden sm:tw-inline">, {timeString}</span>}</span></span>;
    $[18] = dateString;
    $[19] = timeString;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== rankText || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t10 = <div className={t6}>{t7}{rankText}{t8}{t9}</div>;
    $[21] = rankText;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default WinnerDropBadge;